import { render, staticRenderFns } from "./Lesiurpackages.vue?vue&type=template&id=40534aa2&scoped=true"
import script from "./Lesiurpackages.vue?vue&type=script&lang=js"
export * from "./Lesiurpackages.vue?vue&type=script&lang=js"
import style0 from "./Lesiurpackages.vue?vue&type=style&index=0&id=40534aa2&prod&scoped=true&lang=css"
import style1 from "./Lesiurpackages.vue?vue&type=style&index=1&id=40534aa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40534aa2",
  null
  
)

export default component.exports